import React, { useState, useContext, useEffect, useMemo, useRef} from 'react'
import BodySettingsLayout from '../Layouts/BodySettingsLayout'
import BodySection from '../Components/Body/BodySection'
import { Auth } from '../../../../../modules/API/Auth/auth'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../../../../store/reducers/rootReducer'
import { LOGIN_SUCCESS } from '../../../../../../store/actions/actionsTypes'
import { ContextModal } from '../../../../../modules/modal/modalContext'
import axios from 'axios'
import DatabaseIcon from '../../../../../generic/icons/IconLib/DatabaseIcon'
import BuildingIcon from '../../../../../generic/icons/IconLib/BuildingIcon'
import { IInitialState } from '../../../../../../store/initialState'
import { IAuthResponse, ICompanyItem } from '../../../../../modules/API/Auth/models/authDataModel'
import LabeledOptionSelect from './LabeledOptionSelect'
import { IOption } from '../../../../../generic/ui/Selectors/OptionSelect'
import { instance } from '../../../../../modules/API/config'
import InviteLink from './Components/InviteLink'

type IFromatedCompanies = IOption
const AccountIndex = () => {
  const dispatch = useDispatch()
  const user: IInitialState = useSelector((state: RootState) => state.mainReducer)
  const controller = useRef(new AbortController());

  const [modal, setModal] = useContext(ContextModal)
  const [companies, setCompanies] = useState<IFromatedCompanies[]>([])
  const [isLoadCumanies, setIsLoadCumanies] = useState<boolean>(false)

  // Function to display an error message in a modal.
  const errorResponse = () => {
    setModal({
        open: false,
        value: "משהו השתבש",
        mood: true
    });
    setTimeout(() => {
        setModal({
            open: false,
            value: '2'
        });
    }, 3000);
  }

  const updateInstance = (token: string) => {
    instance.updateToken = token
  }
  const patchDatabase = async (id: string | number) => {
    try {
      const res: IAuthResponse = await Auth.patchDataBaseGo(id, 0)
      sessionStorage.clear()
      dispatch({ type: LOGIN_SUCCESS, payload: res })
      updateInstance(res.token)
      localStorage.setItem('user', JSON.stringify(res.token));
      await getInternalCompanies(id)

    } catch (error) {
      errorResponse()
    }
  }

  const getInternalCompanies = async (id: number | string) => {
    setIsLoadCumanies(true)
    try {
        let response = await Auth.getInternalCompanies(id)
        setCompanies(response.map((company: ICompanyItem) => ({value: +company.id, label: company.name})) || [])
    } catch (err) {
      errorResponse()
    } finally {
      setIsLoadCumanies(false)
    }
  }

  const patchCompany = async (id: string | number) => {
    try {
      const res: IAuthResponse = await Auth.patchDataBaseGo(user.current_company_id || 0, id)
      sessionStorage.clear()
      dispatch({ type: LOGIN_SUCCESS, payload: res })
      updateInstance(res.token)
      localStorage.setItem('user', JSON.stringify(res.token));
    } catch {
      errorResponse()
    }
  }

  useEffect(() => {
    getInternalCompanies(user.current_company_id || 0)
    return () => {
      controller.current.abort();
    }
  }, [])

  const companiesList = useMemo(() => {
    return user?.companies?.map(company => ({value: company.id, label: company.name})) || []
  }, [user])

  const isAdmin = useMemo(() => {
    return user?.user?.rights?.includes('ADMIN') ||
      user?.user?.rights?.includes('OFFICE') ||
      user?.user?.rights?.includes('DEV')
  }, [user])

  const currentCompany = useMemo(
    () => companiesList.find((o) => o.value === (user?.current_company_id || 0)) || null,
    [companiesList, user]
  )
  const currentInternal = useMemo(
    () => companies.find((o) => o.value === (Number(user?.current_company_internal) || 0)) || null,
    [companies, user]
  )
  const yearOptions = useMemo<IFromatedCompanies[]>(
    () => [{ value: Number(user?.user?.year) || 0, label: user?.user?.year || '' }],
    [user]
  )

  return (
    <BodySettingsLayout>
      <BodySection title='הגדרות חשבון'>
        <LabeledOptionSelect
          title='מאגר מידע'
          placeholder='מאגר מידע'
          options={companiesList}
          value={currentCompany}
          onSelect={(opt) => opt && patchDatabase(opt.value)}
          disabled={companiesList.length <= 1}
          leadingIcon={<DatabaseIcon />}
        />
        <LabeledOptionSelect
          title='חברה פנימית'
          placeholder='חברה פנימית'
          options={companies}
          value={currentInternal}
          onSelect={(opt) => opt && patchCompany(opt.value)}
          disabled={companies.length <= 1}
          leadingIcon={<BuildingIcon />}
        />
        <LabeledOptionSelect
          title='עונה'
          placeholder='עונה'
          options={yearOptions}
          value={yearOptions[0]}
          onSelect={(opt) => opt && patchDatabase(opt.value)}
          disabled={yearOptions.length <= 1}
          leadingIcon={<BuildingIcon />}
        />
        {isAdmin && (
          <InviteLink />
        )}
      </BodySection>
    </BodySettingsLayout>
  )
}

export default AccountIndex